import Dashboard from './views/Dashboard.svelte'
import DataList from './views/DataList.svelte'
import DataImport from './views/DataImport.svelte'
import DataSource from './views/DataSource.svelte'
import Info from './views/Info.svelte'
import Accessibility from './views/Accessibility.svelte'
import TermsConditions from './views/TermsConditions.svelte'
import ImportApi from './views/ImportApi.svelte'

export const routes = {
  '/': Dashboard,
  '/interfaces': DataList,
  '/interfaces/*': DataSource,
  '/interfaces-import': DataImport,
  '/interfaces-import/*': ImportApi,
  '/info': Info,
  '/accessibility': Accessibility,
  '/terms-conditions': TermsConditions
}